import PropTypes from "prop-types";
import { useEffect } from "react";

const tagEquals = (node, name) => (node.tagName ?? node.nodeName).toLowerCase() === name.toLowerCase();

function InputContextMenu() {
  useEffect(() => {
    function onContextMenu(event) {
      if (tagEquals(event.target, "input")) {
        event.stopPropagation();
      }
    }

    document.addEventListener("contextmenu", onContextMenu, true);

    return () => {
      document.removeEventListener("contextmenu", onContextMenu, true);
    };
  }, []);

  return null;
}

InputContextMenu.propTypes = {};

InputContextMenu.defaultProps = {};

export default InputContextMenu;
